<div class="container">
    <div class="row" *ngFor="let m of cartSummary.PaymentMethods;">
        <div class="col-6 p-0 pb-2">
            <span attr.data-testid="cart-summary-label-{{m.Kind}}">
                {{ m.Label }}
            </span>
            <br *ngIf="m.SubLabel" />
            <small *ngIf="m.SubLabel">{{ m.SubLabel }}</small>
        </div>
        <div class="col-6 p-0 pb-2">
            <ng-container *ngIf="m.Text === 'Digital Delivery'; else regularLabel">
                <span class="float-right"
                        triggers="hover"
                        placement="top"
                        container="body"
                        mdbPopoverHeader="Digital Order"
                        data-testid="digital-delivery-label"
                        mdbPopover="All items in your order are digital. They will be delivered via email."
                >
                    N/A <i class="fas fa-question-circle helper-tooltip"></i>
                </span>
            </ng-container>
            <ng-template #regularLabel>
                <span 
                    class="float-right" 
                    attr.data-testid="cart-summary-value-{{m.Kind}}"
                >{{ m.Text }}</span>
            </ng-template>
        </div>
    </div>
    <div class="row alert alert-success" *ngIf="cartSummary?.totalSavings">
        <div class="col-xs-12" data-testid="cart-page-total-savings">
            <p>Includes Added Savings of {{ cartSummary.totalSavings | currency }}!</p>
        </div>
    </div>
</div>